<template>
    <FormInputContainer class="FormInputRange" :inputId="`I${_uid}`" :label="label" :errors="errors">
      <div class="range-inputs">
        <input
          :id="`I${_uid}-min`"
          v-bind="$attrs"
          :type="type"
          :value="minValue"
          placeholder="Min"
          @input="handleMinInput($event)"
        />
        <span> - </span>
        <input
          :id="`I${_uid}-max`"
          v-bind="$attrs"
          :type="type"
          :value="maxValue"
          placeholder="Max"
          @input="handleMaxInput($event)"
        />
      </div>
    </FormInputContainer>
  </template>
  
  <script>
  import FormInputContainer from './FormInputContainer';
  
  export default {
    name: 'FormInputRange',
    inheritAttrs: false,
  
    components: { FormInputContainer },
  
    props: {
      minValue: { type: [String, Number] },
      maxValue: { type: [String, Number] },
      label: { type: String },
      type: { type: String, default: 'number' },
      errors: { type: Array },
    },
  
    methods: {
      handleMinInput(event) {
        this.$emit('update:min', event.target.value);
      },
      handleMaxInput(event) {
        this.$emit('update:max', event.target.value);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import 'globals.scss';
  
  .FormInputRange {
    .range-inputs {
      display: flex;
      align-items: center;
  
      input {
        @extend %form-control;
        width: 80px;
        text-align: center;
      }
  
      span {
        margin: 0 5px;
      }
    }
  }
  </style>
  